import React from 'react';
import ConventionsPage from './ConventionsPage';

export default function CmcContractsPage() {
  return (
    <ConventionsPage
      contractType="CIPAESSE"
      defaultTitle="Contrat-cadre coopératif C.I.P.A.E.S.S.E"
      headerTitle="Convention cadre C.I.P.A.E.S.S.E"
      subtitle="Conventions individuelles signées entre l'organisme et chaque coopérateur"
      testIdRoot="cipaesse"
    />
  );
}
